import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, BrainIcon, DropletIcon, SunIcon } from 'lucide-react';
export function EnergyFeelCards() {
  const cards = [{
    title: 'Smooth Energy',
    description: 'The lift without the restless edge.',
    icon: ZapIcon
  }, {
    title: 'Clear Focus',
    description: 'Stay switched on through the dip.',
    icon: BrainIcon
  }, {
    title: 'Hydration-First',
    description: 'A better base before the caffeine hits.',
    icon: DropletIcon
  }, {
    title: 'Daily Ritual',
    description: 'One scoop for training days, deep work, and the dip.',
    icon: SunIcon
  }];
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-47">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-4 mb-12" data-id="element-49">
          <h2 className="font-headline text-4xl md:text-5xl text-charcoal" data-id="element-50">
            Built around the way energy should feel.
          </h2>
          <p className="text-lg md:text-xl text-gray-600" data-id="element-51">
            Not wired. Not flat. Not chasing the next coffee.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-52">
          {cards.map((card, i) => {
          const Icon = card.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center" data-id="element-53">
                <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center mb-6" data-id="element-54">
                  <Icon className="w-6 h-6 text-charcoal" data-id="element-55" />
                </div>
                <h3 className="font-bold text-lg text-charcoal mb-3" data-id="element-56">
                  {card.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-57">
                  {card.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}